import styled from 'styled-components';

export const WrapperFileInput = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: 9rem;
`;
